import { selectExternalInfos } from '@/domain/external/external.selectors';
import {
  Co2Section,
  ImpactCo2Answer,
} from '@/domain/impact-co2/entities/question.entity';
import { impactCo2Slice } from '@/domain/impact-co2/impact-co2.slice';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { AccommodationPublicForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/AccommodationPublicForm';
import { MobilityPublicForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/MobilityPublicForm';
import { QuizFormSeparator } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSeparator';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';

export function FormMobilityAccommodation() {
  const sector = 'ANY';
  const source = 'SURVEY';

  const { eventPosition } = useAppSelector(selectExternalInfos);

  const dispatch = useAppDispatch();

  const onSubmit = (answer: ImpactCo2Answer) => {
    const newAnswer: ImpactCo2Answer = { ...answer, id: getNewIdAnswer() };
    dispatch(impactCo2Slice.actions.addImpactAnswer(newAnswer));
  };

  const onEdit = (answer: ImpactCo2Answer) => {
    dispatch(impactCo2Slice.actions.editImpactAnswer(answer));
  };

  const onDelete = (answer: ImpactCo2Answer) => {
    dispatch(impactCo2Slice.actions.removeImpactAnswer(answer));
  };

  return (
    <ImpactQuestionContext.Provider
      value={{ panelOpen: true, hideCompleted: false }}
    >
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.MOBILITY}`)}
      />
      <MobilityPublicForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
        source={source}
        eventPosition={eventPosition}
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.ACCOMMODATION}`)}
      />
      <AccommodationPublicForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
        source={source}
      />
    </ImpactQuestionContext.Provider>
  );
}

let tempAnswerId = 0;

function getNewIdAnswer(): number {
  return tempAnswerId++;
}
